export const GET_USERS = "GET_USERS";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILED = "GET_USER_FAILED";

export const GET_ALL_USERS_DASHBOARD = "GET_ALL_USERS_DASHBOARD";
export const GET_ALL_USERS_DASHBOARD_SUCCESS = "GET_ALL_USERS_DASHBOARD_SUCCESS";
export const GET_ALL_USERS_DASHBOARD_FAILED = "GET_ALL_USERS_DASHBOARD_FAILED";

export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILED = "CREATE_USER_FAILED";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILED = "GET_CURRENT_USER_FAILED";

export const GET_SUMMARY_CASES = "GET_SUMMARY_CASES";
export const GET_SUMMARY_CASES_SUCCESS = "GET_SUMMARY_CASES_SUCCESS";
export const GET_SUMMARY_CASES_FAILED = "GET_SUMMARY_CASES_FAILED";

export const CREATE_CASE = "CREATE_CASE";
export const CREATE_CASE_SUCCESS = "CREATE_CASE_SUCCESS";
export const CREATE_CASE_FAILED = "CREATE_CASE_FAILED";

export const GET_CASE_ID = "GET_CASE_ID";
export const GET_CASE_ID_SUCCESS = "GET_CASE_ID_SUCCESS";
export const GET_CASE_ID_FAILED = "GET_CASE_ID_FAILED";

export const DELETE_CASE = "DELETE_CASE";
export const DELETE_CASE_SUCCESS = "DELETE_CASE_SUCCESS";
export const DELETE_CASE_FAILED = "DELETE_CASE_FAILED";

export const GET_ALL_CASE = "GET_ALL_CASE";
export const GET_ALL_CASE_SUCCESS = "GET_ALL_CASE_SUCCESS";
export const GET_ALL_CASE_FAILED = "GET_ALL_CASE_FAILED";

export const GET_ALL_CASE_DASHBOARD = "GET_ALL_CASE_DASHBOARD";
export const GET_ALL_CASE_DASHBOARD_SUCCESS = "GET_ALL_CASE_DASHBOARD_SUCCESS";
export const GET_ALL_CASE_DASHBOARD_FAILED = "GET_ALL_CASE_DASHBOARD_FAILED";

export const UPDATE_CASE = "UPDATE_CASE";
export const UPDATE_CASE_SUCCESS = "UPDATE_CASE_SUCCESS";
export const UPDATE_CASE_FAILED = "UPDATE_CASE_FAILED";

export const UPDATE_CASE_MANY = "UPDATE_CASE_MANY";
export const UPDATE_CASE_MANY_SUCCESS = "UPDATE_CASE_MANY_SUCCESS";
export const UPDATE_CASE_MANY_FAILED = "UPDATE_CASE_MANY_FAILED";

export const GET_TYPES = "GET_TYPES";
export const GET_TYPES_SUCCESS = "GET_TYPES_SUCCESS";
export const GET_TYPES_FAILED = "GET_TYPES_FAILED";

export const CREATE_SUBCASE = "CREATE_SUBCASE";
export const CREATE_SUBCASE_SUCCESS = "CREATE_SUBCASE_SUCCESS";
export const CREATE_SUBCASE_FAILED = "CREATE_SUBCASE_FAILED";

export const UPDATE_SUBCASE = "UPDATE_SUBCASE";
export const UPDATE_SUBCASE_SUCCESS = "UPDATE_SUBCASE_SUCCESS";
export const UPDATE_SUBCASE_FAILED = "UPDATE_SUBCASE_FAILED";

export const DELETE_SUBCASE = "DELETE_SUBCASE";
export const DELETE_SUBCASE_SUCCESS = "DELETE_SUBCASE_SUCCESS";
export const DELETE_SUBCASE_FAILED = "DELETE_SUBCASE_FAILED";

export const GET_SUBTYPES = "GET_SUBTYPES";
export const GET_SUBTYPES_SUCCESS = "GET_SUBTYPES_SUCCESS";
export const GET_SUBTYPES_FAILED = "GET_SUBTYPES_FAILED";

export const GET_ALL_REGIONS = "GET_ALL_REGIONS";
export const GET_ALL_REGIONS_SUCCESS = "GET_ALL_REGIONS_SUCCESS";
export const GET_ALL_REGIONS_FAILED = "GET_ALL_REGIONS_FAILED";

export const GET_SETTING = "GET_SETTING";
export const GET_SETTING_SUCCESS = "GET_SETTING_SUCCESS";
export const GET_SETTING_FAILED = "GET_SETTING_FAILED";

export const GET_SETTING_URL_CUSTOMER_SERVICE = "GET_SETTING_URL_CUSTOMER_SERVICE";
export const GET_SETTING_URL_CUSTOMER_SERVICE_SUCCESS = "GET_SETTING_URL_CUSTOMER_SERVICE_SUCCESS";
export const GET_SETTING_URL_CUSTOMER_SERVICE_FAILED = "GET_SETTING_URL_CUSTOMER_SERVICE_FAILED";

export const GET_SETTING_URL_PRE_PAID = "GET_SETTING_URL_PRE_PAID";
export const GET_SETTING_URL_PRE_PAID_SUCCESS = "GET_SETTING_URL_PRE_PAID_SUCCESS";
export const GET_SETTING_URL_PRE_PAID_FAILED = "GET_SETTING_URL_PRE_PAID_FAILED";

export const PUT_PRE_PAID = "PUT_PRE_PAID";
export const PUT_PRE_PAID_SUCCESS = "PUT_PRE_PAID_SUCCESS";
export const PUT_PRE_PAID_FAILED = "PUT_PRE_PAID_FAILED";

export const PUT_PORT_CAPTATION = "PUT_PORT_CAPTATION";
export const PUT_PORT_CAPTATION_SUCCESS = "PUT_PORT_CAPTATION_SUCCESS";
export const PUT_PORT_CAPTATION_FAILED = "PUT_PORT_CAPTATION_FAILED";

export const PUT_PORT_CUSTOMER_SERVICE = "PUT_PORT_CUSTOMER_SERVICE";
export const PUT_PORT_CUSTOMER_SERVICE_SUCCESS = "PUT_PORT_CUSTOMER_SERVICE_SUCCESS";
export const PUT_PORT_CUSTOMER_SERVICE_FAILED = "PUT_PORT_CUSTOMER_SERVICE_FAILED";

export const PUT_PORT_RETENTION = "PUT_PORT_RETENTION";
export const PUT_PORT_RETENTION_SUCCESS = "PUT_PORT_RETENTION_SUCCESS";
export const PUT_PORT_RETENTION_FAILED = "PUT_PORT_RETENTION_FAILED";

export const GET_SETTING_URL_PRE_PAID_INTERNAL = "GET_SETTING_URL_PRE_PAID_INTERNAL";
export const GET_SETTING_URL_PRE_PAID_INTERNAL_SUCCESS = "GET_SETTING_URL_PRE_PAID_INTERNAL_SUCCESS";
export const GET_SETTING_URL_PRE_PAID_INTERNAL_FAILED = "GET_SETTING_URL_PRE_PAID_INTERNAL_FAILED";

export const GET_SETTING_URL_PORT_CUSTOMER_SERVICE_REQUEST = "GET_SETTING_URL_PORT_CUSTOMER_SERVICE_REQUEST";
export const GET_SETTING_URL_PORT_CUSTOMER_SERVICE_SUCCESS = "GET_SETTING_URL_PORT_CUSTOMER_SERVICE_SUCCESS";
export const GET_SETTING_URL_PORT_CUSTOMER_SERVICE_FAILURE = "GET_SETTING_URL_PORT_CUSTOMER_SERVICE_FAILURE";

export const GET_SETTING_URL_PORT_CAPTATION_REQUEST = "GET_SETTING_URL_PORT_CAPTATION_REQUEST";
export const GET_SETTING_URL_PORT_CAPTATION_SUCCESS = "GET_SETTING_URL_PORT_CAPTATION_SUCCESS";
export const GET_SETTING_URL_PORT_CAPTATION_FAILURE = "GET_SETTING_URL_PORT_CAPTATION_FAILURE";

export const GET_SETTING_URL_PORT_RETENTION_REQUEST = "GET_SETTING_URL_PORT_RETENTION_REQUEST";
export const GET_SETTING_URL_PORT_RETENTION_SUCCESS = "GET_SETTING_URL_PORT_RETENTION_SUCCESS";
export const GET_SETTING_URL_PORT_RETENTION_FAILURE = "GET_SETTING_URL_PORT_RETENTION_FAILURE";

export const GET_ALL_ROLLS = "GET_ALL_ROLLS";
export const GET_ALL_ROLLS_SUCCESS = "GET_ALL_ROLLS_SUCCESS";
export const GET_ALL_ROLLS_FAILED = "GET_ALL_ROLLS_FAILED";

export const GET_SEXES = "GET_SEXES";
export const GET_SEXES_SUCCESS = "GET_SEXES_SUCCESS";
export const GET_SEXES_FAILED = "GET_SEXES_FAILED";

export const GET_NATIONALITIES = "GET_NATIONALITIES";
export const GET_NATIONALITIES_SUCCESS = "GET_NATIONALITIES_SUCCESS";
export const GET_NATIONALITIES_FAILED = "GET_NATIONALITIES_FAILED";

export const GET_CIVILSTATUS = "GET_CIVILSTATUS";
export const GET_CIVILSTATUS_SUCCESS = "GET_CIVILSTATUS_SUCCESS";
export const GET_CIVILSTATUS_FAILED = "GET_CIVILSTATUS_FAILED";

export const GET_ALL_COMMUNS = "GET_ALL_COMMUNS";
export const GET_ALL_COMMUNS_SUCCESS = "GET_ALL_COMMUNS_SUCCESS";
export const GET_ALL_COMMUNS_FAILED = "GET_ALL_COMMUNS_FAILED";

export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const GET_ALL_NOTIFICATIONS_SUCCESS = "GET_ALL_NOTIFICATIONS_SUCCESS";
export const GET_ALL_NOTIFICATIONS_FAILED = "GET_ALL_NOTIFICATIONS_FAILED";

export const CREATE_EMAIL_TEMPLATE = "CREATE_EMAIL_TEMPLATE";
export const CREATE_EMAIL_TEMPLATE_SUCCESS = "CREATE_EMAIL_TEMPLATE_SUCCESS";
export const CREATE_EMAIL_TEMPLATE_FAILED = "CREATE_EMAIL_TEMPLATE_FAILED";

export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE";
export const GET_EMAIL_TEMPLATE_SUCCESS = "GET_EMAIL_TEMPLATE_SUCCESS";
export const GET_EMAIL_TEMPLATE_FAILED = "GET_EMAIL_TEMPLATE_FAILED";

export const GET_EMAIL_TEMPLATE_ID = "GET_EMAIL_TEMPLATE_ID";
export const GET_EMAIL_TEMPLATE_ID_SUCCESS = "GET_EMAIL_TEMPLATE_ID_SUCCESS";
export const GET_EMAIL_TEMPLATE_ID_FAILED = "GET_EMAIL_TEMPLATE_ID_FAILED";

export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = "UPDATE_EMAIL_TEMPLATE_SUCCESS";
export const UPDATE_EMAIL_TEMPLATE_FAILED = "UPDATE_EMAIL_TEMPLATE_FAILED";

export const DELETE_EMAIL_TEMPLATE = "DELETE_EMAIL_TEMPLATE";
export const DELETE_EMAIL_TEMPLATE_SUCCESS = "DELETE_EMAIL_TEMPLATE_SUCCESS";
export const DELETE_EMAIL_TEMPLATE_FAILED = "DELETE_EMAIL_TEMPLATE_FAILED";

export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';

export const GET_CLIENT_BY_RUT_REQUEST = 'GET_CLIENT_BY_RUT_REQUEST';
export const GET_CLIENT_BY_RUT_SUCCESS = 'GET_CLIENT_BY_RUT_SUCCESS';
export const GET_CLIENT_BY_RUT_FAILURE = 'GET_CLIENT_BY_RUT_FAILURE';

export const GET_CLIENT_PORTAL = 'GET_CLIENT_PORTAL';
export const GET_CLIENT_PORTAL_SUCCESS = 'GET_CLIENT_PORTAL_SUCCESS';
export const GET_CLIENT_PORTAL_FAILURE = 'GET_CLIENT_PORTAL_FAILURE';

export const CREATE_CLIENT = 'CREATE_CLIENT';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE';

export const UPDATE_CLIENT_PASSWORD = 'UPDATE_CLIENT_PASSWORD';
export const UPDATE_CLIENT_PASSWORD_SUCCESS = 'UPDATE_CLIENT_PASSWORD_SUCCESS';
export const UPDATE_CLIENT_PASSWORD_FAILURE = 'UPDATE_CLIENT_PASSWORD_FAILURE';

export const GET_CLIENT_EXISTS = 'GET_CLIENT_EXISTS';
export const GET_CLIENT_EXISTS_SUCCESS = 'GET_CLIENT_EXISTS_SUCCESS';
export const GET_CLIENT_EXISTS_FAILURE = 'GET_CLIENT_EXISTS_FAILURE';

export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';

export const GET_BENEFITS_REQUEST = 'GET_BENEFITS_REQUEST';
export const GET_BENEFITS_SUCCESS = 'GET_BENEFITS_SUCCESS';
export const GET_BENEFITS_FAILURE = 'GET_BENEFITS_FAILURE';

export const GET_PRODUCTS_BY_RUT_REQUEST = 'GET_PRODUCTS_BY_RUT_REQUEST';
export const GET_PRODUCTS_BY_RUT_SUCCESS = 'GET_PRODUCTS_BY_RUT_SUCCESS';
export const GET_PRODUCTS_BY_RUT_FAILURE = 'GET_PRODUCTS_BY_RUT_FAILURE';

export const GET_DOCUMENT_REQUEST = 'GET_DOCUMENT_REQUEST';
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS';
export const GET_DOCUMENT_FAILURE = 'GET_DOCUMENT_FAILURE';

export const GET_ORIGINS = 'GET_ORIGINS';
export const GET_ORIGINS_SUCCESS = 'GET_ORIGINS_SUCCESS';
export const GET_ORIGINS_FAILED = 'GET_ORIGINS_FAILED';

export const GET_EXCEL_CASES = 'GET_EXCEL_CASES';
export const GET_EXCEL_CASES_SUCCESS = 'GET_EXCEL_CASES_SUCCESS';
export const GET_EXCEL_CASES_FAILED = 'GET_EXCEL_CASES_FAILED';